module.exports = __webpack_public_path__ + "static/img/bg-tr.116d2b1a.png";